import type { Valign } from '@atlaskit/adf-schema/valign';

export const MAX_STANDARD_LAYOUT_COLUMNS = 3;
export const MAX_LAYOUT_COLUMNS = 5;
export const MIN_LAYOUT_COLUMN_WIDTH_PERCENT = 5;
export const DEFAULT_LAYOUT_COLUMN_VALIGN: Valign = 'top';

export const EVEN_DISTRIBUTED_COL_WIDTHS: { [key: number]: number } = {
	1: 100,
	2: 50,
	3: 33.33,
	4: 25,
	5: 20,
};
